import React, { useState } from 'react';
import { withRouter } from 'react-router';

import OnboardingWrapper from './OnboardingWrapper';
import { BusinessReports } from '../Business-admin/MenuRedirect';
import FinishTourModal from './Modal/FinishTour';

const PreviewReports = (props) => {
  const { history, match: { path } } = props;
  const [isModalActive, setModalStatus] = useState(true);

  return (
    <OnboardingWrapper isModalActive={isModalActive}>
      <FinishTourModal path={path} history={history} enableHeaderExit={() => setModalStatus(false)} />
      <BusinessReports />
    </OnboardingWrapper>
  )
}

export default withRouter(PreviewReports);



// WEBPACK FOOTER //
// ./src/components/Onboarding/PreviewReports.js